import main from './store/index';
import store from '@/core/store';

export const connect = (opts = {}) => {
  store.registerModule('main$main', main);
};
